module.exports = __webpack_public_path__ + "img/symbol_0.c95e38ce.png";